<img src="/images/pov-ray.png" width="22" alt="POV-Ray icon" />
